import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import 'rxjs/add/operator/map';

import { Globals } from '../providers/globals';
import { HttpHelper } from '../helpers/httpHelper';
import { Storage } from '@ionic/storage';

@Injectable()
export class BusinessProductManagerHandler {
 	url: any;
 	token: any;
  	businessId: any = 0; 

	constructor(
		public http: Http,
		public globals: Globals,
        public storage: Storage,
        public httpHelper: HttpHelper
	){
	}

	getProducts(params){	
	  	this.url = this.globals.dataUrl + 'businessProduct' + 
	                                      '/page/' + params.page +
	                                      '/size/' + params.size;

    	this.storage.get('loginData').then((loginData) => {
	      	this.token = loginData.access_token

		    this.http.get(
		        this.url,
		        this.httpHelper.configOptionsWithToken(loginData.access_token)
		    )
		    .map(res => res.json())
		    .subscribe(res => {
		          if(typeof params.cb == "function") params.cb(res.Data);
		    });   
    	})
  	}

  	getProduct(id, cb){	
	  	this.url = this.globals.dataUrl + 'businessProduct/' + id;

    	this.storage.get('loginData').then((loginData) => {
	      	this.token = loginData.access_token

		    this.http.get(
		        this.url,
		        this.httpHelper.configOptionsWithToken(loginData.access_token)
		    )
		    .map(res => res.json())
		    .subscribe(res => {
		          if(typeof cb == "function") cb(res.Data);
		    });   
    	})
  	}

	createProduct(params, cb){
	    this.url = this.globals.dataUrl + 'businessProduct';

	    this.storage.get('loginData').then((loginData) => {
	      	this.token = loginData.access_token

		    this.http
		    .post(
		      this.url, 
		      params, 
		      this.httpHelper.configOptionsWithToken(this.token)
		    )
		    .map(res => res.json())
		    .subscribe(response => {
		        if(typeof cb == "function") cb(response);
		    });  
		})           
	}

	deleteProduct(id, cb){	
	  	this.url = this.globals.dataUrl + 'businessProduct/' + id;

    	this.storage.get('loginData').then((loginData) => {
	      	this.token = loginData.access_token

		    this.http.delete(
		        this.url,
		        this.httpHelper.configOptionsWithToken(loginData.access_token)
		    )
		    .map(res => res.json())
		    .subscribe(res => {
		          if(typeof cb == "function") cb(res);
		    });   
    	})
  	}

	updateProduct(id, params, cb){
	    this.url = this.globals.dataUrl + 'businessProduct/' + id;

	    this.storage.get('loginData').then((loginData) => {
	      	this.token = loginData.access_token

		    this.http
		    .put(
		      this.url, 
		      params, 
		      this.httpHelper.configOptionsWithToken(this.token)
		    )
		    .map(res => res.json())
		    .subscribe(response => {
		        if(typeof cb == "function") cb(response);
		    }); 
		});             
	}

  	uploadProductImage(params){		
	  	this.url = this.globals.dataUrl + 'businessProduct/image';

    	this.storage.get('loginData').then((loginData) => {
    		console.log("||Before post||");

    		console.log(params.imageString);
    		
		    this.http.post(
		        this.url,
		        {ImagePath: params.imageString,
		         Id: params.id}, 
		        this.httpHelper.configOptionsWithToken(loginData.access_token)
		    )
		    .map(res => {
		    	console.log("||Mapping||");
		    	console.log("||Status||");
		    	console.log(res.status);
			    // If request fails, throw an Error that will be caught
			    if(res.status < 200 || res.status >= 300) {
			      throw new Error('This request has failed ' + res.status);
			    } 
			    // If everything went fine, return the response
			    else {
			      return res.json();
			    }
			})
		    .subscribe(
				(res) => {
					console.log("Returned data:");
					console.log(res);					
					if(typeof params.cb == "function") params.cb(res);
				}, 
				(err) => {
					console.log("Returned error:");
					console.log(err);
				}
		    );   
    	})
  	}

  	deleteProductImage(id, cb){	
	  	this.url = this.globals.dataUrl + 'businessProduct/image/' + id;

    	this.storage.get('loginData').then((loginData) => {
	      	this.token = loginData.access_token

		    this.http.delete(
		        this.url,
		        this.httpHelper.configOptionsWithToken(loginData.access_token)
		    )
		    .map(res => res.json())
		    .subscribe(res => {
		          if(typeof cb == "function") cb(res);
		    });   
    	})
  	}

}



// WEBPACK FOOTER //
// ./src/providers/business-product-handler.ts